import DeviceFwuClient from '../ble/deviceFwuClient';
import fwuPackageService from '../fwu/fwuPackageService';
import connectivityService from './connectivityService';
import fwuTargetService from './fwuTargetService';
import SblFwuClient from './sblFwuClient';

const getFwuClient = (fwu_target) => {
    const doesDeviceSupportSblUpdate = fwuPackageService.checkIfDeviceSupportsSblUpdate(fwu_target);
    const isSblFirmwareType = fwuTargetService.isFwuTargetRequiresSblTypeUpdate(fwu_target);
    const isUsb = connectivityService.isUsb();
    const isSblUpdate = isUsb || (doesDeviceSupportSblUpdate && isSblFirmwareType);
    const FwuClient = isSblUpdate ? SblFwuClient : DeviceFwuClient;

    return FwuClient;
};

export default {getFwuClient};
